export const englishLocales = {
  validation: {
    required: 'Required',
  },
  home: 'Home Page',
  contactUs: 'Contact Us :test',
  login: 'Login',
  login_description: 'Welcome back! Please sign in to your account',
  email: 'Email',
  password: 'Password',
  login_button_text: 'Sign In',
  register: 'Create Account',
  register_description: 'Join us today and start your journey',
  register_button_text: 'Create Account',
  forget_password: 'Forgot Password?',
  forget_password_description: 'Enter your email address and we\'ll send you a link to reset your password',
  forget_button_text: 'Send Reset Link',
  verify_account: 'Verify Your Account',
  verify_description: 'We\'ve sent a verification code to your email. Please enter it below.',
  verification_code: 'Verification Code',
  enter_verification_code: 'Enter verification code',
  didnt_receive_code: 'Didn\'t receive the code?',
  resend_code: 'Resend Code',
  full_name: 'Full Name',
  phone: 'Phone',
  password_confirmation: 'Confirm Password',
  terms_agreement: 'By registering, you agree to our',
  terms_and_conditions: 'Terms and Conditions',
  have_an_account: 'Already have an account?',
  not_have_an_account: 'Don\'t have an account?',
  remember_an_account: 'Remember your password?',
  remember_me: 'Remember me',
  forgot_password: 'Forgot password?',
  email_or_phone: 'Email or Phone',
  forgot_password_success: 'Password reset link sent successfully',
  forgot_password_error: 'Failed to send password reset link',
  verify_forgot_password: 'Verify Password Reset',
  verify_forgot_password_description: 'We\'ve sent a verification code to your email/phone. Please enter it below.',
  verify_code: 'Verify Code',
  verification_success: 'Verification successful',
  verification_error: 'Verification failed',
  reset_password: 'Reset Your Password',
  reset_password_description: 'Enter your new password below',
  new_password: 'New Password',
  confirm_new_password: 'Confirm New Password',
  reset_password_button: 'Reset Password',
  password_reset_success: 'Password reset successfully',
  password_reset_error: 'Failed to reset password',
  remember_password: 'Remember your password?',
  or: 'or',
  loading_text: 'Please wait...',
  integrations: 'Integrations',
  salla_app: 'Salla App',
  salla_settings: 'Salla Settings',

  // Templates
  button_templates: 'Button Templates',
  buttons: 'Buttons',
  button: 'Button',
  add_button: 'Add Button',
  remove_button: 'Remove Button',
  button_text: 'Button Text',
  button_action: 'Button Action',
  button_type: 'Button Type',
  max_buttons_reached: 'Maximum number of buttons reached',
  reply: 'Reply',
  url: 'URL',
  call: 'Call',
  reply_text_placeholder: 'Enter reply text',
  url_placeholder: 'Enter URL (e.g., https://example.com)',
  phone_number_placeholder: 'Enter phone number (e.g., +1234567890)',
  footer_text: 'Footer Text',
  footer_text_placeholder: 'Enter footer text',
  section_title: 'Section Title',
  add_section: 'Add Section',
  remove_section: 'Remove Section',
  add_row: 'Add Row',
  remove_row: 'Remove Row',
  row_title: 'Row Title',
  row_description: 'Row Description',
  sections: 'Sections',
  section: 'Section',
  rows: 'Rows',
  row: 'Row',
  max_sections_reached: 'Maximum sections reached (6)',

  // WordPress Integration
  wordpress_integration: 'WordPress Integration',
  wordpress_integration_description: 'Integrate your WordPress website with Rasil Dashboard',
  download_wordpress_plugin: 'Download WordPress Plugin',
  wordpress_plugin_description:
    'Connect your WordPress website to Rasil Dashboard to manage campaigns, customers, and more.',
  plugin_features: 'Plugin Features',
  easy_integration: 'Easy Integration',
  easy_integration_desc: 'Simple setup process with just a few clicks',
  customer_management: 'Customer Management',
  customer_management_desc: 'Manage your WordPress customers directly from Rasil Dashboard',
  campaign_integration: 'Campaign Integration',
  campaign_integration_desc: 'Create and manage campaigns for your WordPress customers',
  analytics_tracking: 'Analytics & Tracking',
  analytics_tracking_desc: 'Track customer behavior and campaign performance',
  installation_guide: 'Installation Guide',
  installation_step_1: 'Download the plugin file',
  installation_step_2: 'Upload it to your WordPress site via Plugins > Add New > Upload Plugin',
  installation_step_3: 'Activate the plugin',
  installation_step_4: 'Configure your API credentials from Rasil Dashboard',
  installation_step_5: 'Start managing your customers and campaigns!',
  download_now: 'Download Now',
  version: 'Version',
  last_updated: 'Last Updated',
  requirements: 'Requirements',
  requirement_1: 'WordPress 5.0 or higher',
  requirement_2: 'PHP 7.4 or higher',
  requirement_3: 'Rasil Dashboard account',
  plugin_information: 'Plugin Information',
  need_help: 'Need Help?',
  help_description: 'If you encounter any issues during installation or have questions about the integration, please contact our support team.',

  // Zid Integration
  zid_integration: 'Zid Integration',
  zid_integration_description: 'Integrate your Zid store with Rasil Dashboard',
  zid_coming_soon: 'Coming Soon',
  zid_coming_soon_description: 'Zid integration is currently under development. We are working hard to bring you a seamless integration experience.',

  // Shopify Integration
  shopify_integration: 'Shopify Integration',
  shopify_integration_description: 'Integrate your Shopify store with Rasil Dashboard',
  shopify_coming_soon: 'Coming Soon',
           shopify_coming_soon_description: 'Shopify integration is currently under development. We are working hard to bring you a seamless integration experience.',

         // Common Integration Features
         easy_setup: 'Easy Setup',
         easy_setup_description: 'Simple integration process with your store',
         powerful_tools: 'Powerful Tools',
         powerful_tools_description: 'Advanced campaign management and analytics',
         zid_native: 'Zid Native',
         zid_native_description: 'Built specifically for Zid platform',
         shopify_native: 'Shopify Native',
         shopify_native_description: 'Built specifically for Shopify platform',

  // Salla App Translations
  salla: {
    // General
    app_name: 'Salla App',
    overview: 'Overview',
    // abandoned_carts: 'Abandoned Carts',
    orders: 'Orders',
    customers: 'Customers',
    reviews: 'Reviews',
    admin_notifications: 'Admin Notifications',
    widget_settings: 'Widget Settings',

    // Store Info
    store_name: 'Store Name',
    store_id: 'Store ID',
    store_url: 'Store URL',
    visit_store: 'Visit Store',

    // Actions
    refresh: 'Refresh',
    save_changes: 'Save Changes',
    save_all_changes: 'Save All Changes',
    edit: 'Edit',
    cancel: 'Cancel',
    save: 'Save',
    back_to_dashboard: 'Back to Dashboard',
    add: 'Add',
    add_integration: 'Add Integration',
    add_new_integration: 'Add New Integration',

    // Status & Messages
    settings_updated: 'Settings updated successfully!',
    no_changes: 'No changes to save',
    saving: 'Saving...',
    refreshing: 'Refreshing...',
    loading: 'Loading...',
    no_settings_found: 'No settings found',

    // Tab Labels
    order_settings: 'Order Settings',
    customer_settings: 'Customer Settings',
    abandoned_carts_settings: 'Abandoned Carts',
    review_settings: 'Review Settings',
    admin_notifications_settings: 'Admin Notifications',
    widget_settings_label: 'Widget Settings',
    general_settings: 'General Settings',

    // Setting Types
    enabled: 'Enabled',
    disabled: 'Disabled',
    text: 'Text',
    number: 'Number',
    select_option: 'Select option',
    enter_text: 'Enter text...',
    enter_image_url: 'Enter image URL...',
    click_to_select_image: 'Click to select image',
    select_image: 'Select Image',
    image_preview: 'Image Preview',
    upload_image: 'Upload Image',
    drag_drop_image: 'Drag & drop image here, or click to select',
    enter_color_value: 'Enter color value...',

    // Common Settings
    instance_id: 'Instance ID',
    access_token: 'Access Token',
    message: 'Message',
    image: 'Image',
    color: 'Color',
    phone: 'Phone',
    url: 'URL',
    type: 'Type',
    unit: 'Unit',
    position: 'Position',
    status: 'Status',
    value: 'Value',
    count: 'Count',
    times: 'Times',

    // Order Settings
    new_order: 'New Order',
    payment_pending: 'Payment Pending',
    payment_method_cod: 'Payment Method COD',
    under_review: 'Under Review',
    in_progress: 'In Progress',
    delivering: 'Delivering',
    delivered: 'Delivered',
    shipped: 'Shipped',
    completed: 'Completed',
    canceled: 'Canceled',
    restoring: 'Restoring',
    restored: 'Restored',
    request_quote: 'Request Quote',
    review: 'Review',
    review_trigger: 'Review Trigger',
    review_delay: 'Review Delay',
    review_reminder: 'Review Reminder',

    // Customer Settings
    send_activation_code: 'Send Activation Code',
    customer_otp: 'Customer OTP',
    welcome_customer: 'Welcome Customer',

    // Abandoned Carts
    abandoned_cart: 'Abandoned Cart',
    interval: 'Interval',

    // Campaigns
    campaigns: 'Campaigns',
    manage_campaigns: 'Manage Campaigns',
    table_view_campaigns: 'Table View Campaigns',
    create_campaign: 'Create Campaign',
    campaign: 'Campaign',
    progress: 'Progress',
    statistics: 'Statistics',
    created: 'Created',
    campaign_name: 'Campaign Name',
    campaign_name_required: 'Campaign name is required',
    enter_campaign_name: 'Enter campaign name',
    send_to_all_abandoned_carts: 'Send to all abandoned carts',
    cart_ids: 'Cart IDs',
    select_carts_or_send_to_all: 'Please select specific cart IDs or choose to send to all',
    enter_cart_ids_comma_separated: 'Enter cart IDs separated by commas (e.g., 1001, 1002, 1003)',
    campaign_message: 'Campaign Message',
    enter_custom_message: 'Enter custom message (optional)',
    notes: 'Notes',
    enter_notes: 'Enter notes (optional)',
    creating: 'Creating...',
    error_creating_campaign: 'Error creating campaign',
    no_campaigns_found: 'No campaigns found',
    select_abandoned_carts: 'Select Abandoned Carts',
    select_all: 'Select All',
    search_carts: 'Search carts by customer name or email...',
    loading_carts: 'Loading abandoned carts...',
    no_carts_found: 'No carts found matching your search',
    no_abandoned_carts: 'No abandoned carts available',
    unknown_customer: 'Unknown Customer',
    no_email: 'No email',
    currency: 'SAR',
    abandoned_at: 'Abandoned at',
    selected_carts_count: 'Selected :count cart(s)',
    page: 'Page',
    // Time filters and pagination
    time_filter: 'Time Filter',
    all_time: 'All Time',
    last_7_days: 'Last 7 Days',
    last_30_days: 'Last 30 Days',
    last_90_days: 'Last 90 Days',
    items_per_page: 'Items per page',
    first_page: 'First Page',
    last_page: 'Last Page',
    loading_campaigns: 'Loading campaigns...',
    search_campaigns: 'Search campaigns...',
    all_statuses: 'All Statuses',
    draft: 'Draft',
    ready: 'Ready',
    paused: 'Paused',
    //  completed: 'Completed',
    failed: 'Failed',
    start: 'Start',
    pause: 'Pause',
    complete: 'Complete',
    retry: 'Retry',
    start_campaign: 'Start Campaign',
    pause_campaign: 'Pause Campaign',
    complete_campaign: 'Complete Campaign',
    retry_campaign: 'Retry Campaign',
    // Additional campaign-related keys
    id_label: 'ID',
    total_campaigns: 'Total Campaigns',
    active_campaigns: 'Active Campaigns',
    campaign_status_breakdown: 'Campaign Status Breakdown',
    performance_metrics: 'Performance Metrics',
    messages_sent: 'Messages Sent',
    messages_failed: 'Messages Failed',
    messages_pending: 'Messages Pending',
    showing_page: 'Showing page',
    please_connect_salla_store: 'Please connect a Salla store first',
    actions: 'Actions',
    skipped: 'Skipped',
    carts: 'Carts',
    sent: 'Sent',
    items: 'Items',
    store: 'Store',
    //  failed: 'Failed',
    pending: 'Pending',

    // Review Settings
    post_rating_feedback: 'Post Rating Feedback',
    excellent: 'Excellent',
    very_good: 'Very Good',
    good: 'Good',
    bad: 'Bad',
    coupon: 'Coupon',
    coupon_type: 'Coupon Type',
    coupon_value: 'Coupon Value',
    max_discount: 'Max Discount',
    free_shipping: 'Free Shipping',
    expires_in_days: 'Expires in Days',
    percentage: 'Percentage',
    fixed: 'Fixed',

    // Admin Notifications
    admin_new_order: 'Admin New Order',
    admin_low_stock: 'Admin Low Stock',
    phones: 'Phones',

    // Widget Settings
    show_whatsapp_widget: 'Show WhatsApp Widget',
    whatsapp_widget_logo: 'WhatsApp Widget Logo',
    whatsapp_widget_phone: 'WhatsApp Widget Phone',
    default_message: 'Default Message',
    show_status: 'Show Status',
    status_text: 'Status Text',
    qrcode_enabled: 'QR Code Enabled',
    popup_text: 'Popup Text',
    button_text: 'Button Text',
    margin: 'Margin',
    button_size: 'Button Size',
    primary_color: 'Primary Color',
    hover_color: 'Hover Color',

    // Time Units
    hours: 'Hours',
    days: 'Days',
    weeks: 'Weeks',
    months: 'Months',

    // Positions
    left: 'Left',
    right: 'Right',
    bottom: 'Bottom',
    top: 'Top',

    // Statuses
    cancelled: 'Cancelled',

    // Messages
    loading_salla_integrations: 'Loading Salla integrations...',
    store_not_found: 'Store not found',
    no_integrations: 'No Salla integrations found',
    no_integrations_found: 'No Salla integrations found',
    no_integrations_yet: 'No integrations yet',
    no_integrations_description:
      'Connect your Salla store to start managing abandoned carts, campaigns, and settings.',
    visit_salla_apps: 'Visit Salla Apps',
    how_to_integrate: 'How to integrate with Salla',
    integration_step_1: 'Visit the Salla Apps marketplace to find our app',
    integration_step_2: 'Install and configure the app in your Salla store',
    integration_step_3: 'Return here to manage your store data and settings',
    error_fetching_integrations: 'Error fetching integrations',
    error_fetching_settings: 'Error fetching settings',
    error_updating_setting: 'Error updating setting',
    error_updating_settings: 'Error updating settings',

    // Statistics
    total_carts: 'Total Carts',
    total_value: 'Total Value',
    average_cart_value: 'Average Cart Value',
    conversion_rate: 'Conversion Rate',

    // Filters
    search: 'Search',
    filter_by_time: 'Filter by Time',
    sort_by: 'Sort by',
    total: 'Total',
    updated_at: 'Updated At',

    // Pagination
    // showing: 'Showing',
    to: 'to',
    of: 'of',
    results: 'results',
    previous: 'Previous',
    next: 'Next',

    // Cart Details
    customer_name: 'Customer Name',
    customer_email: 'Customer Email',
    customer_phone: 'Customer Phone',
    cart_total: 'Cart Total',
    cart_items_count: 'Cart Items Count',
    age_in_minutes: 'Age in Minutes',
    created_at: 'Created At',
    checkout_url: 'Checkout URL',

    // Notifications
    local_notifications: 'Local Notifications',
    status_sent: 'Sent',
    status_pending: 'Pending',
    converted: 'Converted',
    reminder_count: 'Reminder Count',
    sent_at: 'Sent At',

    // Additional keys for SallaAppPage
    your_integrations: 'Your Integrations',
    connected_at: 'Connected At',
    manage_abandoned_carts: 'Manage and recover abandoned carts',
    manage_settings: 'Configure app settings and preferences',
    integration_stats: 'Integration Statistics',
    active: 'Active',
    enter_store_name: 'Enter store name',
    enter_store_url: 'Enter store URL',
    enter_store_id: 'Enter store ID',

    // Additional keys for AbandonedCartsPage
    no_salla_integrations_found: 'No Salla Integrations Found',
    need_to_set_up_salla_integration_first:
      'You need to set up a Salla integration first to view abandoned carts.',
    loading_abandoned_carts_data: 'Loading your abandoned carts data...',
    updating_search_results: 'Updating your search results...',
    updating_results: 'Updating results...',
    abandoned_carts: 'Abandoned Carts ({count})',

    // Abandoned Carts Management
    abandoned_carts_management: 'Abandoned Carts Management',
    track_and_recover_abandoned_carts: 'Track and recover abandoned shopping carts',
    syncing: 'Syncing...',
    sync_from_salla: 'Sync from Salla',

    // Statistics
    total_abandoned: 'Total Abandoned',
    recovery_rate: 'Recovery Rate',
    pending_recovery: 'Pending Recovery',

    // Filters and Search
    showing_carts_from: 'Showing carts from:',
    //  all_time: 'All Time',
    last_7_hours: 'Last 7 Hours',
    last_week: 'Last Week',
    last_month: 'Last Month or More',
    search_customers_categories: 'Search customers, categories...',
    sort_by_abandoned_date: 'Sort by Abandoned Date',
    sort_by_last_updated: 'Sort by Last Updated',
    sort_by_total_value: 'Sort by Total Value',
    sort_by_customer_name: 'Sort by Customer Name',

    // Cart List
    no_abandoned_carts_found: 'No abandoned carts found',
    try_adjusting_search_terms: 'Try adjusting your search terms',
    all_carts_recovered_or_processing: 'All carts have been recovered or are being processed',

    // Cart Item
    cart_id: 'Cart ID',
    attempts: 'Attempts',
    cart_value: 'Cart Value',
    contacted: 'Contacted',
    contact: 'Contact',
    recovered: 'Recovered',
    mark_recovered: 'Mark Recovered',

    // Time-related translations for getTimeAgo
    less_than_1_hour: 'Less than 1 hour ago',
    hours_ago: '{count} hours ago',
    days_ago: '{count} days ago',
    weeks_ago: '{count} weeks ago',

    // Settings Header
    settings_header: {
      title: 'Settings Management',
      description: 'Configure and manage your Salla app settings',
      saving: 'Saving...',
      saveAllChanges: 'Save All Changes',
      backToDashboard: 'Back to Dashboard',
    },

    // Additional Settings Keys
    modified: 'Modified',
    settings_for_store: 'Settings for :store',
    store_integration_not_found: 'The requested store integration could not be found.',
    loading_settings: 'Loading settings...',
    no_settings_for_category: 'No settings found for the {category} category.',
    not_set: 'Not set',

    // Toast Messages
    success: 'Success',
    error: 'Error',
    info: 'Information',
    warning: 'Warning',
    campaign_created_successfully: 'Campaign created successfully',
    campaign_updated_successfully: 'Campaign updated successfully',
    campaign_deleted_successfully: 'Campaign deleted successfully',
    campaign_started_successfully: 'Campaign started successfully',
    campaign_paused_successfully: 'Campaign paused successfully',
    campaign_completed_successfully: 'Campaign completed successfully',
    campaign_retry_successfully: 'Campaign retry initiated successfully',
    failed_to_create_campaign: 'Failed to create campaign',
    failed_to_update_campaign: 'Failed to update campaign',
    failed_to_delete_campaign: 'Failed to delete campaign',
    failed_to_start_campaign: 'Failed to start campaign',
    failed_to_pause_campaign: 'Failed to pause campaign',
    failed_to_complete_campaign: 'Failed to complete campaign',
    failed_to_retry_campaign: 'Failed to retry campaign',
    settings_saved_successfully: 'Settings saved successfully',
    failed_to_save_settings: 'Failed to save settings',
    integration_added_successfully: 'Integration added successfully',
    failed_to_add_integration: 'Failed to add integration',
    abandoned_carts_synced_successfully: 'Abandoned carts synced successfully from Salla',
    failed_to_sync_abandoned_carts: 'Failed to sync abandoned carts from Salla',
    cart_status_updated_successfully: 'Cart status updated successfully',
    failed_to_update_cart_status: 'Failed to update cart status',
    no_integration_selected: 'No integration selected',
    invalid_action: 'Invalid action',

    // Setting Title Keys
    setting_titles: {
      instance_id: 'Instance ID',
      access_token: 'Access Token',
      new_order_enabled: 'New Order Enabled',
      new_order_message: 'New Order Message',
      new_order_image: 'New Order Image',
      payment_pending_enabled: 'Payment Pending Enabled',
      payment_pending_message: 'Payment Pending Message',
      payment_pending_image: 'Payment Pending Image',
      payment_method_cod_enabled: 'Payment Method COD Enabled',
      payment_method_cod_message: 'Payment Method COD Message',
      payment_method_cod_image: 'Payment Method COD Image',
      under_review_enabled: 'Under Review Enabled',
      under_review_message: 'Under Review Message',
      under_review_image: 'Under Review Image',
      in_progress_enabled: 'In Progress Enabled',
      in_progress_message: 'In Progress Message',
      in_progress_image: 'In Progress Image',
      delivering_enabled: 'Delivering Enabled',
      delivering_message: 'Delivering Message',
      delivering_image: 'Delivering Image',
      delivered_enabled: 'Delivered Enabled',
      delivered_message: 'Delivered Message',
      delivered_image: 'Delivered Image',
      shipped_enabled: 'Shipped Enabled',
      shipped_message: 'Shipped Message',
      shipped_image: 'Shipped Image',
      completed_enabled: 'Completed Enabled',
      completed_message: 'Completed Message',
      completed_image: 'Completed Image',
      canceled_enabled: 'Canceled Enabled',
      canceled_message: 'Canceled Message',
      canceled_image: 'Canceled Image',
      restoring_enabled: 'Restoring Enabled',
      restoring_message: 'Restoring Message',
      restoring_image: 'Restoring Image',
      restored_enabled: 'Restored Enabled',
      restored_message: 'Restored Message',
      restored_image: 'Restored Image',
      request_quote_enabled: 'Request Quote Enabled',
      request_quote_message: 'Request Quote Message',
      request_quote_image: 'Request Quote Image',
      review_enabled: 'Review Enabled',
      review_trigger_status: 'Review Trigger Status',
      review_delay_unit: 'Review Delay Unit',
      review_delay_value: 'Review Delay Value',
      review_message: 'Review Message',
      review_image: 'Review Image',
      review_reminder_enabled: 'Review Reminder Enabled',
      review_reminder_times: 'Review Reminder Times',
      review_reminder_interval_unit: 'Review Reminder Interval Unit',
      review_reminder_interval_value: 'Review Reminder Interval Value',
      review_reminder_message: 'Review Reminder Message',
      send_activation_code_enabled: 'Send Activation Code Enabled',
      customer_otp_message: 'Customer OTP Message',
      welcome_customer_enabled: 'Welcome Customer Enabled',
      welcome_customer_message: 'Welcome Customer Message',
      welcome_customer_image: 'Welcome Customer Image',
      abandoned_cart_enabled: 'Abandoned Cart Enabled',
      abandoned_cart_interval_unit: 'Abandoned Cart Interval Unit',
      abandoned_cart_interval_value: 'Abandoned Cart Interval Value',
      abandoned_cart_message: 'Abandoned Cart Message',
      abandoned_cart_image: 'Abandoned Cart Image',
      post_rating_feedback_excellent_enabled: 'Post Rating Feedback Excellent Enabled',
      post_rating_feedback_excellent_message: 'Post Rating Feedback Excellent Message',
      post_rating_feedback_excellent_image: 'Post Rating Feedback Excellent Image',
      post_rating_feedback_excellent_coupon_type: 'Post Rating Feedback Excellent Coupon Type',
      post_rating_feedback_excellent_coupon_value: 'Post Rating Feedback Excellent Coupon Value',
      post_rating_feedback_excellent_coupon_max_discount:
        'Post Rating Feedback Excellent Coupon Max Discount',
      post_rating_feedback_excellent_coupon_free_shipping:
        'Post Rating Feedback Excellent Coupon Free Shipping',
      post_rating_feedback_excellent_coupon_expires_in_days:
        'Post Rating Feedback Excellent Coupon Expires In Days',
      post_rating_feedback_very_good_enabled: 'Post Rating Feedback Very Good Enabled',
      post_rating_feedback_very_good_message: 'Post Rating Feedback Very Good Message',
      post_rating_feedback_very_good_image: 'Post Rating Feedback Very Good Image',
      post_rating_feedback_very_good_coupon_type: 'Post Rating Feedback Very Good Coupon Type',
      post_rating_feedback_very_good_coupon_value: 'Post Rating Feedback Very Good Coupon Value',
      post_rating_feedback_very_good_coupon_max_discount:
        'Post Rating Feedback Very Good Coupon Max Discount',
      post_rating_feedback_very_good_coupon_free_shipping:
        'Post Rating Feedback Very Good Coupon Free Shipping',
      post_rating_feedback_very_good_coupon_expires_in_days:
        'Post Rating Feedback Very Good Coupon Expires In Days',
      post_rating_feedback_good_enabled: 'Post Rating Feedback Good Enabled',
      post_rating_feedback_good_message: 'Post Rating Feedback Good Message',
      post_rating_feedback_good_image: 'Post Rating Feedback Good Image',
      post_rating_feedback_good_coupon_type: 'Post Rating Feedback Good Coupon Type',
      post_rating_feedback_good_coupon_value: 'Post Rating Feedback Good Coupon Value',
      post_rating_feedback_good_coupon_max_discount:
        'Post Rating Feedback Good Coupon Max Discount',
      post_rating_feedback_good_coupon_free_shipping:
        'Post Rating Feedback Good Coupon Free Shipping',
      post_rating_feedback_good_coupon_expires_in_days:
        'Post Rating Feedback Good Coupon Expires In Days',
      post_rating_feedback_bad_enabled: 'Post Rating Feedback Bad Enabled',
      post_rating_feedback_bad_message: 'Post Rating Feedback Bad Message',
      post_rating_feedback_bad_image: 'Post Rating Feedback Bad Image',
      post_rating_feedback_bad_coupon_type: 'Post Rating Feedback Bad Coupon Type',
      post_rating_feedback_bad_coupon_value: 'Post Rating Feedback Bad Coupon Value',
      post_rating_feedback_bad_coupon_max_discount: 'Post Rating Feedback Bad Coupon Max Discount',
      post_rating_feedback_bad_coupon_free_shipping: 'Enable free shipping for bad rating coupons',
      post_rating_feedback_bad_coupon_expires_in_days:
        'Post Rating Feedback Bad Coupon Expires In Days',
      admin_new_order_enabled: 'Admin New Order Enabled',
      admin_new_order_phones: 'Admin New Order Phones',
      admin_new_order_message: 'Admin New Order Message',
      admin_low_stock_enabled: 'Admin Low Stock Enabled',
      admin_low_stock_phones: 'Admin Low Stock Phones',
      admin_low_stock_message: 'Admin Low Stock Message',
      show_whatsapp_widget: 'Show WhatsApp Widget',
      whatsapp_widget_logo: 'WhatsApp Widget Logo',
      whatsapp_widget_phone: 'WhatsApp Widget Phone',
      whatsapp_widget_default_message: 'WhatsApp Widget Default Message',
      whatsapp_widget_show_status: 'WhatsApp Widget Show Status',
      whatsapp_widget_status_text: 'WhatsApp Widget Status Text',
      whatsapp_widget_qrcode_enabled: 'WhatsApp Widget QR Code Enabled',
      whatsapp_widget_popup_text: 'WhatsApp Widget Popup Text',
      whatsapp_widget_button_text: 'WhatsApp Widget Button Text',
      whatsapp_widget_position: 'WhatsApp Widget Position',
      whatsapp_widget_margin: 'WhatsApp Widget Margin',
      whatsapp_widget_button_size: 'WhatsApp Widget Button Size',
      whatsapp_widget_primary_color: 'WhatsApp Widget Primary Color',
      whatsapp_widget_hover_color: 'WhatsApp Widget Hover Color',
    },

    // Helper Text Keys
    helper: {
      instance_id: 'Unique identifier for this integration instance',
      access_token: 'Authentication token for accessing Salla API',
      new_order_enabled: 'Enable notifications for new orders',
      new_order_message: 'Message template for new order notifications',
      new_order_image: 'Image to include with new order notifications',
      payment_pending_enabled: 'Enable notifications for pending payments',
      payment_pending_message: 'Message template for payment pending notifications',
      payment_pending_image: 'Image to include with payment pending notifications',
      payment_method_cod_enabled: 'Enable notifications for COD payment method orders',
      payment_method_cod_message: 'Message template for COD payment method notifications',
      payment_method_cod_image: 'Image to include with COD payment method notifications',
      under_review_enabled: 'Enable notifications for orders under review',
      under_review_message: 'Message template for under review notifications',
      under_review_image: 'Image to include with under review notifications',
      in_progress_enabled: 'Enable notifications for orders in progress',
      in_progress_message: 'Message template for in progress notifications',
      in_progress_image: 'Image to include with in progress notifications',
      delivering_enabled: 'Enable notifications for delivering orders',
      delivering_message: 'Message template for delivering notifications',
      delivering_image: 'Image to include with delivering notifications',
      delivered_enabled: 'Enable notifications for delivered orders',
      delivered_message: 'Message template for delivered notifications',
      delivered_image: 'Image to include with delivered notifications',
      shipped_enabled: 'Enable notifications for shipped orders',
      shipped_message: 'Message template for shipped notifications',
      shipped_image: 'Image to include with shipped notifications',
      completed_enabled: 'Enable notifications for completed orders',
      completed_message: 'Message template for completed notifications',
      completed_image: 'Image to include with completed notifications',
      canceled_enabled: 'Enable notifications for canceled orders',
      canceled_message: 'Message template for canceled notifications',
      canceled_image: 'Image to include with canceled notifications',
      restoring_enabled: 'Enable notifications for restoring orders',
      restoring_message: 'Message template for restoring notifications',
      restoring_image: 'Image to include with restoring notifications',
      restored_enabled: 'Enable notifications for restored orders',
      restored_message: 'Message template for restored notifications',
      restored_image: 'Image to include with restored notifications',
      request_quote_enabled: 'Enable notifications for quote requests',
      request_quote_message: 'Message template for quote request notifications',
      request_quote_image: 'Image to include with quote request notifications',
      review_enabled: 'Enable automatic review requests for orders',
      review_trigger_status: 'Order status that triggers review request',
      review_delay_unit: 'Time unit for review delay',
      review_delay_value: 'Number of time units to wait before sending review request',
      review_message: 'Message template for review requests',
      review_image: 'Image to include with review requests',
      review_reminder_enabled: 'Enable reminder notifications for reviews',
      review_reminder_times: 'Number of reminder notifications to send',
      review_reminder_interval_unit: 'Time unit for reminder intervals',
      review_reminder_interval_value: 'Number of time units between reminders',
      review_reminder_message: 'Message template for review reminders',
      send_activation_code_enabled: 'Enable sending activation codes to new customers',
      customer_otp_message: 'Message template for customer OTP verification',
      welcome_customer_enabled: 'Enable welcome messages for new customers',
      welcome_customer_message: 'Message template for customer welcome messages',
      welcome_customer_image: 'Image to include with welcome messages',
      abandoned_cart_enabled: 'Enable abandoned cart recovery notifications',
      abandoned_cart_interval_unit: 'Time unit for abandoned cart notification intervals',
      abandoned_cart_interval_value:
        'Number of time units to wait before sending abandoned cart notifications',
      abandoned_cart_message: 'Message template for abandoned cart recovery',
      abandoned_cart_image: 'Image to include with abandoned cart notifications',
      post_rating_feedback_excellent_enabled: 'Enable feedback for excellent ratings',
      post_rating_feedback_excellent_message: 'Message template for excellent rating feedback',
      post_rating_feedback_excellent_image: 'Image to include with excellent rating feedback',
      post_rating_feedback_excellent_coupon_type: 'Type of coupon for excellent ratings',
      post_rating_feedback_excellent_coupon_value: 'Value of coupon for excellent ratings',
      post_rating_feedback_excellent_coupon_max_discount:
        'Maximum discount amount for excellent rating coupons',
      post_rating_feedback_excellent_coupon_free_shipping:
        'Enable free shipping for excellent rating coupons',
      post_rating_feedback_excellent_coupon_expires_in_days:
        'Number of days until excellent rating coupon expires',
      post_rating_feedback_very_good_enabled: 'Enable feedback for very good ratings',
      post_rating_feedback_very_good_message: 'Message template for very good rating feedback',
      post_rating_feedback_very_good_image: 'Image to include with very good rating feedback',
      post_rating_feedback_very_good_coupon_type: 'Type of coupon for very good ratings',
      post_rating_feedback_very_good_coupon_value: 'Value of coupon for very good ratings',
      post_rating_feedback_very_good_coupon_max_discount:
        'Maximum discount amount for very good rating coupons',
      post_rating_feedback_very_good_coupon_free_shipping:
        'Enable free shipping for very good rating coupons',
      post_rating_feedback_very_good_coupon_expires_in_days:
        'Number of days until very good rating coupon expires',
      post_rating_feedback_good_enabled: 'Enable feedback for good ratings',
      post_rating_feedback_good_message: 'Message template for good rating feedback',
      post_rating_feedback_good_image: 'Image to include with good rating feedback',
      post_rating_feedback_good_coupon_type: 'Type of coupon for good ratings',
      post_rating_feedback_good_coupon_value: 'Value of coupon for good ratings',
      post_rating_feedback_good_coupon_max_discount:
        'Maximum discount amount for good rating coupons',
      post_rating_feedback_good_coupon_free_shipping:
        'Enable free shipping for good rating coupons',
      post_rating_feedback_good_coupon_expires_in_days:
        'Number of days until good rating coupon expires',
      post_rating_feedback_bad_enabled: 'Enable feedback for bad ratings',
      post_rating_feedback_bad_message: 'Message template for bad rating feedback',
      post_rating_feedback_bad_image: 'Image to include with bad rating feedback',
      post_rating_feedback_bad_coupon_type: 'Type of coupon for bad ratings',
      post_rating_feedback_bad_coupon_value: 'Value of coupon for bad ratings',
      post_rating_feedback_bad_coupon_max_discount:
        'Maximum discount amount for bad rating coupons',
      post_rating_feedback_bad_coupon_free_shipping: 'Enable free shipping for bad rating coupons',
      post_rating_feedback_bad_coupon_expires_in_days:
        'Number of days until bad rating coupon expires',
      admin_new_order_enabled: 'Enable admin notifications for new orders',
      admin_new_order_phones: 'Phone numbers to receive new order notifications (comma-separated)',
      admin_new_order_message: 'Message template for admin new order notifications',
      admin_low_stock_enabled: 'Enable admin notifications for low stock',
      admin_low_stock_phones: 'Phone numbers to receive low stock notifications (comma-separated)',
      admin_low_stock_message: 'Message template for admin low stock notifications',
      show_whatsapp_widget: 'Show WhatsApp widget on your store',
      whatsapp_widget_logo: 'Logo image for the WhatsApp widget',
      whatsapp_widget_phone: 'Phone number for WhatsApp widget',
      whatsapp_widget_default_message: 'Default message when customers click WhatsApp widget',
      whatsapp_widget_show_status: 'Show online/offline status in WhatsApp widget',
      whatsapp_widget_status_text: 'Custom text to show in status area',
      whatsapp_widget_qrcode_enabled: 'Enable QR code generation for WhatsApp widget',
      whatsapp_widget_popup_text: 'Text to show in widget popup',
      whatsapp_widget_button_text: 'Text to display on the widget button',
      whatsapp_widget_position: 'Position of the WhatsApp widget on the page',
      whatsapp_widget_margin: 'Margin distance from the edge of the page (in pixels)',
      whatsapp_widget_button_size: 'Size of the widget button (in pixels)',
      whatsapp_widget_primary_color: 'Primary color for the WhatsApp widget',
      whatsapp_widget_hover_color: 'Color when hovering over the WhatsApp widget',

      // Short Codes
      short_codes: {
        available_codes: 'Available Short Codes',
        click_to_insert: 'Click to insert at cursor position',
        codes: 'codes',
        usage_hint:
          'Click on any short code above to insert it into your message at the current cursor position',
      },
    },
    you_can_edit: 'You can edit the data',
    // Template selection
    choose_template: 'Choose Template',
    select_template_or_manual: 'Select template or add manually',
    refresh_templates: 'Refresh Templates',
    template_loaded: 'Template Loaded',
    clear_template: 'Clear Template',
  },

  // Bot Builder Nodes
  conversation_end: 'Conversation End',
  finish_node_description: 'This node marks the end of the conversation flow. The bot will stop responding after this point.',
  bot_will_stop: 'The bot will stop responding after this node.',
  remove_node: 'Remove Node',
  start_node: 'Start',
  start_node_description: 'This is the starting point of your chatbot flow.',
  text_message: 'Text Message',
  text_message_description: 'Send a simple text message to the user.',
  image_message: 'Image Message',
  image_message_description: 'Send an image with an optional caption.',
  video_message: 'Video Message',
  video_message_description: 'Send a video with an optional caption.',
  audio_message: 'Audio Message',
  audio_message_description: 'Send an audio file with an optional caption.',
  document_message: 'Document Message',
  document_message_description: 'Send a document file with an optional caption.',
  location_message: 'Location Message',
  location_message_description: 'Send a location to the user.',
  contact_message: 'Contact Message',
  contact_message_description: 'Send contact information to the user.',
  sticker_message: 'Sticker Message',
  sticker_message_description: 'Send a sticker to the user.',
  button_message: 'Button Message',
  button_message_description: 'Send a message with interactive buttons.',
  list_message: 'List Message',
  list_message_description: 'Send a message with a list of options.',
  api_request: 'API Request',
  api_request_description: 'Make an API request within the bot flow.',
  apiRequest: 'API Request',
  apiRequestDescription: 'Make a request to an API endpoint.',
  chatgpt_node: 'ChatGPT',
  chatgpt_node_description: 'Integrate with ChatGPT for AI responses.',
  save_variable: 'Save Variable',
  save_variable_description: 'Save a variable from user input.',
  upload_file: 'Upload File',
  enter_url: 'Enter URL',
  caption: 'Caption',
  enter_caption: 'Enter caption text',
  enter_text: 'Enter message text',
  enter_title: 'Enter title',
  enter_description: 'Enter description',
  enter_name: 'Enter name',
  enter_phone: 'Enter phone number',
  enter_email: 'Enter email address',
  enter_company: 'Enter company name',
  enter_job_title: 'Enter job title',
  enter_address: 'Enter address',
  enter_latitude: 'Enter latitude',
  enter_longitude: 'Enter longitude',
  enter_url_placeholder: 'Enter URL (e.g., https://example.com)',
  enter_phone_placeholder: 'Enter phone number (e.g., +1234567890)',
  enter_email_placeholder: 'Enter email address',
  enter_name_placeholder: 'Enter contact name',
  enter_company_placeholder: 'Enter company name',
  enter_job_title_placeholder: 'Enter job title',
  enter_address_placeholder: 'Enter address',
  enter_latitude_placeholder: 'Enter latitude coordinate',
  enter_longitude_placeholder: 'Enter longitude coordinate',
  drag_drop_file: 'Drag and drop a file here, or click to select',
  drag_drop_image: 'Drag and drop an image here, or click to select',
  drag_drop_video: 'Drag and drop a video here, or click to select',
  drag_drop_audio: 'Drag and drop an audio file here, or click to select',
  drag_drop_document: 'Drag and drop a document here, or click to select',
  drag_drop_sticker: 'Drag and drop a sticker here, or click to select',
  temperature: 'Temperature',
  temperature_description: 'Controls the randomness of the AI response',
  model: 'Model',
  select_model: 'Select AI model',
  prompt: 'Prompt',
  enter_prompt: 'Enter your prompt for the AI',
  max_tokens: 'Max Tokens',
  enter_max_tokens: 'Enter maximum number of tokens',
  api_url: 'API URL',
  enter_api_url: 'Enter the API endpoint URL',
  api_method: 'API Method',
  api_headers: 'Headers',
  api_response_info: 'API response data can be accessed using variables like',
  http_method: 'HTTP Method',
  headers: 'Headers',
  body_parameters: 'Body Parameters',
  test_api: 'Test API',
  testing: 'Testing',
  optional: 'Optional',
  add: 'Add',
  key: 'Key',
  value: 'Value',
  api_body: 'Body',
  api_response: 'Response',
  api_status: 'Status',
  api_timeout: 'Timeout',
  enter_timeout: 'Enter timeout in seconds',
  variable_name: 'Variable Name',
  enter_variable_name: 'Enter the name for the variable',
  variable_value: 'Variable Value',
  enter_variable_value: 'Enter the value to save',

  // Additional Bot Builder Keys
  focused: 'Focused',
  creative: 'Creative',
  gpt_node_info: 'This node integrates with ChatGPT to provide AI-powered responses based on the selected prompt and model settings.',
  selectAPrompt: 'Select a Prompt',
  upload_image: 'Upload Image',
  upload_image_url: 'Image URL',
  enter_image_url: 'Enter image URL',
  enter_message_here: 'Enter your message here...',
  message: 'Message',
  image: 'Image',
  keyword: 'Keyword',
  enter_keyword: 'Enter keyword',
  match_type: 'Match Type',
  contains_keywords: 'Contains Keywords',
  must_match_keywords: 'Must Match Keywords',
  all_keywords: 'All Keywords',
  add_keyword: 'Add Keyword',
  remove: 'Remove',
  insert_emoji: 'Insert Emoji',
  addOption: 'Add Option',
  enter_option_text: 'Enter option text',
  save: 'Save',
  cancel: 'Cancel',
  edit: 'Edit',
  anyMessage: 'Any Message',
  no_options_added: 'No options added yet',
  add_options_to_continue: 'Add options to continue',
  
  // Bot Builder Categories
  category_messages: 'Messages',
  category_flow_control: 'Flow Control',
  category_integrations: 'Integrations',
  category_data: 'Data',
  category_other: 'Other',
  
  // Video Tutorial
  watchTutorial: 'Watch Tutorial',
  howItWorks: 'How it Works',
  websiteTutorial: 'Website Tutorial',
  tutorialDescription: 'Learn how to use our platform',
  tutorialDescriptionText: 'This video will guide you through the main features and help you get started with our platform.',
  
  // API Token Page
  api_token_management: 'API Token Management',
  api_token_description: 'Manage your API tokens for secure access to our services',
  security_warning: 'Security Warning',
  api_token_security_note: 'Keep your API token secure and never share it publicly. Regenerate it if compromised.',
  your_api_token: 'Your API Token',
  api_token_subtitle: 'Use this token to authenticate API requests',
  api_token: 'API Token',
  no_token_generated: 'No token generated yet',
  copied: 'Copied',
  copy: 'Copy',
  regenerating: 'Regenerating...',
  view_api_docs: 'View API Documentation',
  how_to_use: 'How to Use',
  api_token_usage_instructions: 'Include this token in the Authorization header of your API requests',
  best_practices: 'Best Practices',
  api_token_best_practices: 'Store tokens securely, rotate regularly, and never commit them to version control',
  copied_to_clipboard: 'Copied to clipboard',
  failed_to_copy: 'Failed to copy',
  
  // Package Page
  subscription_overview: 'Subscription Overview',
  subscription_overview_description: 'View and manage your current subscription details and features',
  no_active_subscription: 'No Active Subscription',
  subscription_required_message: 'You need an active subscription to access premium features',
  choose_plan: 'Choose Plan',
  trial_period: 'Trial Period',
  status_ended: 'Ended',
  status_trial: 'Trial',
  status_active: 'Active',
  upgrade_plan: 'Upgrade Plan',
  price: 'Price',
  billing_cycle: 'Billing Cycle',
  start_date: 'Start Date',
  end_date: 'End Date',
  subscription_title: 'Plan Features',
  not_enabled: 'Not Enabled',
  enabled: 'Enabled',
  
  // QR Code Page
  connection_steps: 'Connection Steps',
  alternative_login: 'Alternative Login',
  qr_code_alternative_description: 'If you have trouble scanning the QR code, you can use the phone number verification method below.',
  scan_qr_code: 'Scan QR Code',
  qr_code_loading: 'Loading QR Code...',
  regenerate_qr: 'Regenerate QR Code',
  qr_code_expires_in: 'QR code expires in 2 minutes',
  
  // PM2 Monitor
  pm2: {
    process_monitor: 'PM2 Process Monitor',
    monitor_and_manage_processes: 'Monitor and manage your PM2 processes in real-time',
    auto_refresh: 'Auto Refresh',
    interval: 'Interval',
    refresh: 'Refresh',
    refreshing: 'Refreshing...',
    processes: 'Processes',
    loading_processes: 'Loading processes...',
    no_processes_found: 'No processes found',
    start_pm2_processes: 'Start some PM2 processes to see them here',
    cpu: 'CPU',
    memory: 'Memory',
    uptime: 'Uptime',
    restarts: 'Restarts',
    restart: 'Restart',
    stop: 'Stop',
    start: 'Start',
    delete: 'Delete',
    details: 'Details',
    select_process: 'Select a Process',
    status: 'Status',
    process_id: 'Process ID',
    cpu_usage: 'CPU Usage',
    exec_path: 'Exec Path',
    working_directory: 'Working Directory',
    recent_logs: 'Recent Logs',
    no_logs_available: 'No logs available',
    choose_process_from_list: 'Choose a process from the list to view detailed information and logs',
    error: 'Error',
    to_fix_this_issue: 'To fix this issue',
    install_pm2_globally: 'Install PM2 globally',
    or_add_pm2_to_path: 'Or add PM2 to your system PATH',
    or_restart_server: 'Or restart your server after PM2 installation',
  },

  // Contacts Management
  contacts_management: 'Contacts Management',
  contacts: 'Contacts',
  contact_groups: 'Contact Groups',
}
